import React from 'react'

import { IRegisterTableField } from '@src/components/register/tablefields/FieldTypes'
import { RegisterColumnDefinition } from '@src/types/register'

export default function EmptyField(props: IRegisterTableField<RegisterColumnDefinition>) {
    return <span />
}
